import { DynamicTextEditor } from '@aon/aon-tws-common-ui';
import * as _ from 'lodash';
import * as React from 'react';
import Constants from '../../../constants';
import { TranslationEditorContainer } from '../../../containers/translations/TranslationEditorContainer';
import ContentConstants from '../../../contentConstants';
import { ISurveyEditModel, ITranslationEditItem } from '../../../models';
import { ClearDiv, Col3Col9, LabelAbove } from '../../common';
import { CollapsableSection } from '../../common/layouts/CollapsableSection';

export interface ITextToSpeechInstructionsSectionProps {
	surveyEditModel: ISurveyEditModel;
	HandleInstructionsChange: (input: string) => void;
	HandleInstructionsUpdate: (item: ITranslationEditItem) => void;
}

export class TextToSpeechInstructionsSection extends React.Component<ITextToSpeechInstructionsSectionProps> {
	public render() {
		const { surveyEditModel } = this.props;
		const { supportedCultures } = surveyEditModel;
		return (
			<CollapsableSection id={'survey-title-intro'} sectionHeader={ContentConstants.SECTIONHEADERS_SURVEY_TEXTTOSPEECH_INSTRUCTIONS}>
				<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_INSTRUCTIONS}>
					<LabelAbove type='input'>{ContentConstants.INPUTLABEL_SURVEY_TEXTTOSPEECH_INSTRUCTIONS}</LabelAbove>
					<DynamicTextEditor
						id='survey-text-to-speech-instructions-editor'
						inputType='textarea'
						enableHtmlEditor={true}
						placeholder={ContentConstants.SUBSECTIONHEADERS_INSTRUCTIONS}
						onChange={this.props.HandleInstructionsChange}
						value={surveyEditModel.textToSpeechInstructions.textValue}
						htmlEditorMode={'custom'}
						toolbarConfiguration={Constants.customHtmlEditorOptions}
					/>
					<ClearDiv clearHeight={'15px'} />
					{surveyEditModel.survey.surveyId !== 0 && (
						<TranslationEditorContainer
							enableHtmlEditor={true}
							property={'text-to-speech'}
							inputType={'textarea'}
							propertyDisplayName={ContentConstants.SURVEY_TEXT_TO_SPEECH_INSTRUCTIONS_PROPERTY_DISPLAYNAME}
							supportedCultures={supportedCultures}
							uniqueId={surveyEditModel.survey.surveyId}
							surveyId={surveyEditModel.survey.surveyId}
							defaultTranslation={surveyEditModel.textToSpeechInstructions}
							notifyUpdate={this.props.HandleInstructionsUpdate}
						/>
					)}
				</Col3Col9>
			</CollapsableSection>
		);
	}
}
